import { useEffect } from 'react';
import installSelectSheetRuntime from './selectSheetRuntime';
import './selectSheetSearch.less';

/**
 * Phones: searchable selects open their bottom sheet on tap without focusing
 * (and raising the keyboard for) their own field — see selectSheetRuntime.ts.
 * Mount once per app; `noSheetClass` marks dropdowns that are not sheets.
 */
const useSelectSheetRuntime = (enabled: boolean, noSheetClass: string) => {
  useEffect(() => {
    if (!enabled) return undefined;
    return installSelectSheetRuntime({ noSheetClass });
  }, [enabled, noSheetClass]);
};

export default useSelectSheetRuntime;
